// extracted by mini-css-extract-plugin
export default {"container":"VendorListContainer_container__SaS4D"};